/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Submit_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to submit embed job: {error}" |
*
* @param {Embed_Captions_Submit_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submit_failed = /** @type {((inputs: Embed_Captions_Submit_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submit_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la soumission de la tache d'incrustation : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Absenden des Einbettungsauftrags: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile inviare il lavoro di incorporamento: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось отправить задание на встраивание: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo enviar el trabajo de inserción: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交嵌入作业失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`埋め込みジョブの送信に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`एम्बेड जॉब सबमिट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao enviar tarefa de incorporação: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to submit embed job: ${i?.error}`)
});